var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Afspraak maken verstopping")]),_c('AppointmentDetail',{attrs:{"allow-editing":"","allow-editing-problem-type":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }